'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var range = require('@mx/util/range');
var raf = require('@mx/util/raf');
var utils = require('../utils');

var length = 3140;
var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "progress-ring",
      style: "width: ".concat(_vm.size, "; height: ").concat(_vm.size)
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 1060 1060"
      }
    }, [_c('path', {
      staticClass: "progress-ring-hover",
      style: _vm.hoverStyle,
      attrs: {
        "d": "M 530 530 m -500, 0 a 500, 500 0 1, 1 1000, 0 a 500, 500 0 1, 1 -1000, 0"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "progress-ring-layer",
      style: _vm.layerStyle,
      attrs: {
        "d": "M 530 530 m -500, 0 a 500, 500 0 1, 1 1000, 0 a 500, 500 0 1, 1 -1000, 0"
      }
    })]), _vm._v(" "), _vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'progress-ring',
  props: {
    value: Number,
    size: {
      type: String,
      default: '2rem'
    },
    fill: {
      type: String,
      default: 'none'
    },
    duration: {
      type: Number,
      default: 0
    },
    rate: {
      type: Number,
      default: 100
    },
    layerColor: {
      type: String,
      default: '#fff'
    },
    color: {
      type: String,
      required: true
    },
    strokeWidth: {
      type: Number,
      default: 30
    },
    clockwise: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      endRate: 0,
      rafId: 0,
      increase: false,
      startTime: 0,
      startRate: 0
    };
  },
  computed: {
    hoverStyle: function hoverStyle() {
      return {
        fill: "".concat(this.fill),
        stroke: "".concat(this.layerColor),
        strokeWidth: "".concat(this.strokeWidth, "px")
      };
    },
    layerStyle: function layerStyle() {
      var offset = length * (100 - this.value) / 100;
      offset = this.clockwise ? offset : length * 2 - offset;
      return {
        stroke: "".concat(this.color),
        strokeDashoffset: "".concat(offset, "px"),
        strokeWidth: "".concat(this.strokeWidth + 1, "px")
      };
    }
  },
  mounted: function mounted() {
    this.watchRate();
  },
  methods: {
    watchRate: function watchRate() {
      this.startTime = Date.now();
      this.startRate = this.value;
      this.endRate = range.range(this.rate, [0, 100]);
      this.increase = this.endRate > this.startRate;

      if (this.duration) {
        raf.cancel(this.rafId);
        this.rafId = raf.raf(this.progress);
      } else {
        this.$emit('input', this.endRate);
      }
    },
    progress: function progress() {
      var now = Date.now();
      var progress = Math.min((now - this.startTime) / this.duration, 1);
      var rate = progress * (this.endRate - this.startRate) + this.startRate;
      this.$emit('input', range.range(parseFloat(rate.toFixed(1)), [0, 100]));

      if (this.increase ? rate < this.endRate : rate > this.endRate) {
        this.rafId = raf.raf(this.progress);
      }
    }
  },
  watch: {
    rate: function rate() {
      this.watchRate();
    }
  }
});

exports.default = index;
